export async function resolvePreferredAssistantVoice(
  synth: SpeechSynthesis,
): Promise<SpeechSynthesisVoice | null> {
  const voices = await readSpeechSynthesisVoices(synth);
  if (!voices.length) return null;

  const scored = voices
    .filter((voice) => /^en[-_]/i.test(voice.lang || ""))
    .map((voice) => ({
      voice,
      score: scoreAssistantVoice(voice),
    }))
    .sort((a, b) => b.score - a.score);

  return scored[0]?.voice ?? null;
}

function readSpeechSynthesisVoices(
  synth: SpeechSynthesis,
): Promise<SpeechSynthesisVoice[]> {
  const voices = synth.getVoices();
  if (voices.length || typeof window === "undefined") {
    return Promise.resolve(voices);
  }

  return new Promise((resolve) => {
    const finish = () => {
      window.clearTimeout(timeout);
      synth.removeEventListener("voiceschanged", finish);
      resolve(synth.getVoices());
    };
    const timeout = window.setTimeout(finish, 250);
    synth.addEventListener("voiceschanged", finish, { once: true });
  });
}

function scoreAssistantVoice(voice: SpeechSynthesisVoice): number {
  const name = voice.name.toLowerCase();
  const lang = voice.lang.toLowerCase();
  let score = lang.startsWith("en-gb") ? 28 : lang.startsWith("en-us") ? 10 : 6;
  if (voice.localService) score += 4;

  const preferred = [
    "daniel",
    "serena",
    "kate",
    "martha",
    "google uk english female",
    "google uk english male",
    "samantha",
    "ava",
    "allison",
    "zoe",
    "nicky",
    "susan",
    "karen",
    "moira",
    "serena",
    "alex",
  ];
  const rank = preferred.findIndex((candidate) => name.includes(candidate));
  if (rank >= 0) score += 40 - rank * 2;
  if (name.includes("enhanced") || name.includes("premium")) score += 8;
  if (name.includes("compact") || name.includes("novelty")) score -= 12;
  if (name.includes("google")) score -= 4;
  return score;
}
